module.exports = __webpack_public_path__ + "static/media/play-button.56f099c4.svg";